import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ErrorResponse } from 'src/app/models/error.model';

@Component({
    selector: 'app-external-broker-access',
    templateUrl: './external-broker-access.component.html',
    styleUrls: ['./external-broker-access.component.scss']
})
export class ExternalBrokerAccessComponent implements OnInit {

    error?: string;
    errorCode?: string;

    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit(): void {
        if (this.authService.getLogged()) {
            this.authService.logout();
        }
        this.route.queryParams.subscribe(params => {
            if (params.associateQrid && params.token) {
                this.error = undefined;
                this.login(params.associateQrid, params.token);
            } else {
                this.error = 'No se informaron los datos necesarios para que podamos iniciar tu sesión en Garantor. En caso de ya disponer de un usuario podés intentar ingresar de forma manual.';
            }
        });
    }

    login(associateQrid: string, token: string) {
        this.authService.externalLogin(associateQrid, token).subscribe(
            session => {
                if (session.token)
                    this.authService.saveToken(session.token);
                if (session.usuario)
                    this.authService.saveUser(session.usuario);
                this.router.navigate(['']);
            },
            (error: ErrorResponse) => {
                this.error = error.error?.descripcion ?? 'Error desconocido';
                this.errorCode = error.error?.codigo;
            }
        );
    }

}
